import SuggestEdit from './SuggestEdit';

export default SuggestEdit;
